import { render, staticRenderFns } from "./DamageAssessorCaseVehicleCard.vue?vue&type=template&id=17478caa&scoped=true"
import script from "./DamageAssessorCaseVehicleCard.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseVehicleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17478caa",
  null
  
)

export default component.exports